import { render, staticRenderFns } from "./evaluatingStandard.vue?vue&type=template&id=22b2d72d&scoped=true&"
import script from "./evaluatingStandard.vue?vue&type=script&lang=ts&"
export * from "./evaluatingStandard.vue?vue&type=script&lang=ts&"
import style0 from "./evaluatingStandard.vue?vue&type=style&index=0&id=22b2d72d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2d72d",
  null
  
)

export default component.exports